export const downAni = (second) => {
    return `infinityDown ${second}s infinite`;
}